import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getAuth } from "firebase/auth";
import { getFirestore, enableIndexedDbPersistence, CACHE_SIZE_UNLIMITED } from "firebase/firestore";

// Keep the flag comparison inline. Create React App replaces it with a
// literal, and webpack then drops the unused branch from the bundle.
let firebaseConfig;
if (process.env.REACT_APP_USE_EMULATORS === "true") {
  firebaseConfig = require("./emulatorFirebase").emulatorFirebaseConfig;
} else {
  firebaseConfig = require("./firebaseEnvironment").productionFirebaseConfig;
}

const app = initializeApp(firebaseConfig);

export const db = getFirestore(app);
export const auth = getAuth(app);

if (process.env.REACT_APP_USE_EMULATORS === "true") {
  require("./emulatorFirebase").connectEmulators(auth, db);
} else {
  enableIndexedDbPersistence(db, {
    synchronizeTabs: true,
    cacheSizeBytes: CACHE_SIZE_UNLIMITED
  }).catch((err) => {
    if (err.code === 'failed-precondition') {
      console.warn("Multiple tabs open, persistence can only be enabled in one tab at a time.");
    } else if (err.code === 'unimplemented') {
      console.warn("The current browser doesn't support persistence");
    }
  });
}

export const analytics = process.env.REACT_APP_USE_EMULATORS === "true"
  ? null
  : getAnalytics(app);
